import React from "react";
import { observer } from "mobx-react-lite";
import { Routes, Route } from "react-router-dom";

import { useStore } from "../store";

import Home from "../pages/Home";
import Users from "../pages/Users";
import Login from "../pages/Login";
import NotFound from "../pages/NotFound";
import Layout from "../containers/Layout";
import Loading from "../components/Loading";
import PrivacyPolicy from "../pages/PrivacyPolicy";

function Routers() {
  const store = useStore();

  if (store.loading) {
    return (
      <Loading
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: `translate(-50%,-100%)`,
        }}
      />
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/users" element={<Users />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default observer(Routers);
